import { createSlice } from "@reduxjs/toolkit";


export const validatePaymentSlice = createSlice({
  name: "validatePayment",
  initialState: {
    isLoading: false,
    validatePaymentData: [],
    message: "",
  },
  reducers: {
    onValidatePayment: (state) => {
      return {
        ...state,
        isLoading: true,
        validatePaymentData: [],
        message: "",
      };
    },

    onValidatePaymentSuccess: (state, { payload }) => {
      const { data = [], status_code = 200 } = payload;
      return {
        ...state,
        isLoading: false,
        validatePaymentData: data,
        status_code,
      };
    },

    onValidatePaymentError: (state, { payload }) => {
      const { data = [], message = "", status_code = 400, errorCode = 1456 } = payload;
      return {
        ...state,
        validatePaymentData: data,
        message,
        status_code,
        errorCode,
        isLoading: false,
      };
    },
    onValidatePaymentReset: (state) => {
      return {
        ...state,
        isLoading: false,
        validatePaymentData: [],
        message: "",
        errorCode: null,
        status_code: null,
      };
    },
  },
});
export const {
  onValidatePayment,
  onValidatePaymentSuccess,
  onValidatePaymentError,
  onValidatePaymentReset,
} = validatePaymentSlice.actions;

export default validatePaymentSlice.reducer;
